var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (
    _vm.estimatedBotFuelTimeInSeconds &&
      _vm.estimatedBotFuelTimeInSeconds > 0
  )?_c('v-layout',{staticClass:"text-extra-small caption--text mt-1",attrs:{"d-flex":"","align-center":"","justify-center":""}},[_c('div',[_vm._v(" Your "),_c('b',[_vm._v("OBT")]),_vm._v(" will run out in "),_c('span',{staticClass:"red--text font-weight-medium"},[_vm._v("~"+_vm._s(_vm.formatSecondsToMinutesHoursOrDays(_vm.estimatedBotFuelTimeInSeconds)))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }